// @flow

import { PAYEE_TYPES } from '../../lib/constants'

/**
 * Given an array of PAYEE_TYPES from assess-capabilities API via sendmoneyserv
 * returns whether or not payer can send/request via mobile phone based on payer
 * country (if API call was made with no payee then it represents whether or not
 * the payer can send/request via mobile phone to _at least some_ country but not
 * necessarily _all_ countries, otherwise it represents the capability to the payee)
 *
 * @param {SupportedPayeeTypes} supportedPayeeTypes - supported_payee_types field
 * @returns {boolean} - whether or not payer can send/request via mobile phone
 */
export function canPhoneSendRequest(supportedPayeeTypes: SupportedPayeeTypes) {
  if (!Array.isArray(supportedPayeeTypes)) {
    return false
  }

  return supportedPayeeTypes.includes(PAYEE_TYPES.PHONE)
}
